import { Component } from '@angular/core';

@Component({
    selector: 'kt-scroll-top',
    templateUrl: './scroll-top.component.html',
    standalone: false
})
export class ScrollTopComponent {

}
